import { withInstall } from '@jdesign-vue/utils'
import DatePicker from './src/date-picker'

export const JdDatePicker = withInstall(DatePicker)
export default JdDatePicker

export * from './src/constants'
export * from './src/props/date-picker'
export type { DatePickerInstance } from './src/instance'
